import { Component } from '@angular/core';
import * as RelationType from '@app/modules/relation-type/reducers';
import { Store } from '@ngrx/store';
import * as RelationTypeApiActions from '@app/modules/relation-type/actions/relation-type-api.actions';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { RelationTypeChangeSequenceModel } from '@app/modules/relation-type/models';
import { ClaimTypes, ClaimValues } from '@app/shared/models/common/constants';

@Component({
    selector: 'app-relation-type-overview',
    templateUrl: './relation-type-overview.component.html',
    styleUrls: ['./relation-type-overview.component.less']
})
export class RelationTypeOverviewComponent {
    tableData$ = this.store.select(RelationType.selectRelationTypeOverviewState);

    ClaimTypes = ClaimTypes;
    ClaimValues = ClaimValues;

    constructor(private readonly store: Store) { }

    onDeleteConfirm(id: number): void {
        this.store.dispatch(RelationTypeApiActions.Delete({ id: id }))
    }

    /**
     * Trigger the loading of data whenever the table changes.
     * The default pageSize, index and sort options are based on the TableStateModel.
     * @param params 
     */
    onQueryParamsChange(params: NzTableQueryParams) {
        const { pageSize, pageIndex, sort, filter } = params;
        const currentSort = sort.find(item => item.value !== null);
        const sortField = (currentSort?.key) ?? null;
        const sortOrder = (currentSort?.value) ?? null;

        this.store.dispatch(RelationTypeApiActions.FilterOverview({
            pagination: {
                page: pageIndex,
                pageSize
            },
            sorting: {
                propertyName: sortField ?? '',
                order: !!sortField ? (sortOrder === 'ascend' ? 'ASC' : 'DESC') : ''
            }
        }));
    }

    onResetOverview() {
        this.store.dispatch(RelationTypeApiActions.ResetOverview());
    }

    onSequenceChange(request: RelationTypeChangeSequenceModel) {
        this.store.dispatch(RelationTypeApiActions.ChangeSequence(request))
    }
}